'use client';

/* eslint-disable react/no-array-index-key */
import { c as _c } from "react/compiler-runtime";
import React from 'react';
import ProgressiveImage from '@/ui/segments/landing/components/progressive-image/progressive-image';
import { IconChevronLeft } from '@/ui/segments/landing/icons/icon-chevron-left';
import { IconChevronRight } from '@/ui/segments/landing/icons/icon-chevron-right';
import { styleBlockFullWidth } from '@/ui/segments/landing/styles';
import { classNames } from '@/util/utils';
import Button from './button';
import type { ContentForMilestones } from '@/services/sanity/api/get-milestones';
import '@/ui/segments/landing/styles.module.css';
import styles from './milestones.module.css';
interface MilestonesProps {
  className?: string;
  data: ContentForMilestones;
}
export default function WidgetMilestones(t0) {
  const $ = _c(48);
  const {
    className,
    data
  } = t0;
  const [index, setIndex] = React.useState(0);
  const milestone = data[index];
  let t1;
  if ($[0] !== data.length || $[1] !== index) {
    t1 = () => {
      if (data.length < 1) {
        return;
      }
      setIndex((index - 1 + data.length) % data.length);
    };
    $[0] = data.length;
    $[1] = index;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handlePrev = t1;
  let t2;
  if ($[3] !== data.length || $[4] !== index) {
    t2 = () => {
      if (data.length < 1) {
        return;
      }
      setIndex((index + 1) % data.length);
    };
    $[3] = data.length;
    $[4] = index;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleNext = t2;
  if (!milestone) {
    return null;
  }
  let t3;
  if ($[6] !== className) {
    t3 = classNames(className, styles.milestones, styleBlockFullWidth);
    $[6] = className;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <hr className={styles.ruler} />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== milestone.title) {
    t5 = <h1>{milestone.title}</h1>;
    $[9] = milestone.title;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== milestone.neurons) {
    t6 = milestone.neurons && <div>{milestone.neurons} neurons</div>;
    $[11] = milestone.neurons;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== milestone.astrocytes) {
    t7 = milestone.astrocytes && <div>{milestone.astrocytes} astrocytes</div>;
    $[13] = milestone.astrocytes;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <div className={styles.counts}>{t6}{t7}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== milestone.description) {
    t9 = <p>{milestone.description}</p>;
    $[18] = milestone.description;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== milestone.imageHeight || $[21] !== milestone.imageURL || $[22] !== milestone.imageWidth) {
    t10 = <ProgressiveImage className={styles.image} src={milestone.imageURL} width={milestone.imageWidth} height={milestone.imageHeight} />;
    $[20] = milestone.imageHeight;
    $[21] = milestone.imageURL;
    $[22] = milestone.imageWidth;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <IconChevronLeft />;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== handlePrev) {
    t12 = <Button onClick={handlePrev}>{t11}</Button>;
    $[25] = handlePrev;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== data || $[28] !== index) {
    let t14;
    if ($[30] !== index) {
      t14 = (_, idx) => <Button key={`${idx}`} onClick={() => setIndex(idx)}><div className={classNames(styles.dash, idx === index && styles.selected)} /></Button>;
      $[30] = index;
      $[31] = t14;
    } else {
      t14 = $[31];
    }
    t13 = data.map(t14);
    $[27] = data;
    $[28] = index;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[32] !== t13) {
    t14 = <div>{t13}</div>;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <IconChevronRight />;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== handleNext) {
    t16 = <Button onClick={handleNext}>{t15}</Button>;
    $[35] = handleNext;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t12 || $[38] !== t14 || $[39] !== t16) {
    t17 = <footer>{t12}{t14}{t16}</footer>;
    $[37] = t12;
    $[38] = t14;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t10 || $[42] !== t17 || $[43] !== t3 || $[44] !== t5 || $[45] !== t8 || $[46] !== t9) {
    t18 = <div className={t3}>{t4}{t5}{t8}{t9}{t10}{t17}</div>;
    $[41] = t10;
    $[42] = t17;
    $[43] = t3;
    $[44] = t5;
    $[45] = t8;
    $[46] = t9;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  return t18;
}